import { useState } from 'react';
import { ConsultancyService } from '../../services/consultancy/consultancyService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage consultancies fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de asesorías.
----------------------------------------------------------------------------------------*/

const useConsultancies = (initialFilters = {}) => {

    const [data, setData] = useState<any[]>([]);
    const filters = {
        limit: 200,
        filter_filters: { ...initialFilters }
    };

    const fetchConsultancies = async (f?: any) => {
        const newFilters = { ...filters, filter_filters: { ...filters.filter_filters, ...f } };
        try {
            const response = await (new ConsultancyService()).listConsultancies(newFilters);
            const fetchedData = response.getResponseData()?.data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string; name: string; }) => ({
                    value: data.id,
                    label: data.name,
                }));
                setData(mappedData);
                return mappedData;
            }
        } catch (error) {
            console.log('Error fetching consultancies:', error);
        }
    };

    const getConsultanciesList = () => {
        return data;
    };

    return { fetchConsultancies, getConsultanciesList };
}

export default useConsultancies;